import { Box, Container, Divider, Fade, Flex, Heading, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react"

import {
  Banner,
  CustomedSpinner,
  PageHeader,
} from "../../shared/components";
import bannerImage from "../../img/bannerTv/telew_top.jpg";
import { BannerClass } from "../../shared/components/Banner/utils";
import { useUserData } from "../../hooks/useUserData";
import { env } from "../../env";
import { useTr069Details } from "../../hooks/useTr069Details";
import { formatClock, timestampToDateString } from "../../shared/utils";
import { useTr069AcsData } from "../../hooks/useTr069AcsData";

export const InternetDevice: FC = () => {
  const { id } = useParams();
  const { data, isLoading } = useTr069Details(id?.toString() || "");
  const { acsData } = useTr069AcsData(id?.toString() || "");
  const userData = useUserData();

  const {
    profileData,
    serialNumber,
    modelName,
    macAddress,
    services,
    creationDate,
    ports,
    wifi
  } = data;

  const { lastSeen } = acsData;




  const bannerDetails = new BannerClass(env.REACT_APP_USE_USER_CODE === 'true' ? userData.data?.usercode : userData.data?.userno);

  if (isLoading) {
    return <CustomedSpinner />;
  }

  return (
    <>
      <Banner bannerImage={bannerImage} {...bannerDetails} />
      <Fade in={true}>
        <Container maxWidth={"container.xl"} flexDir={"column"}  >
          <PageHeader title={modelName} buttonText="Urządzenia" />
          <Box
            bg="white"
            p={6}
            mt={6}
            borderRadius="md"
            // boxShadow="md"
            width="100%"
          >
            <Heading fontSize="md" mb={2}>Ogólne</Heading>
            <Table variant="simple" size="sm">
              <Tbody>
                <Tr><Td fontWeight="bold">Nazwa</Td><Td>{modelName || "Brak"}</Td></Tr>
                <Tr><Td fontWeight="bold">MAC</Td><Td>{macAddress || "Brak"}</Td></Tr>
                <Tr><Td fontWeight="bold">Numer seryjny</Td><Td>{serialNumber || "Brak"}</Td></Tr>
                <Tr><Td fontWeight="bold">Adres IP</Td><Td>{services.internet.AddressIP || "Brak"}</Td></Tr>
                <Tr><Td fontWeight="bold">Ostatni odczyt</Td><Td>{lastSeen ? timestampToDateString(Number(lastSeen) * 1000) + ' ' + formatClock(Number(lastSeen) * 1000) : "Brak daty"}</Td></Tr>
              </Tbody>
            </Table>

            <Divider my={6} />

            <Heading fontSize="md" mb={2}>Usługi</Heading>
            {services && Object.keys(services).length ? (
              <Box pl={2} mb={6}>
                <Flex wrap="wrap" gap={4}>
                  {Object.entries(services).map(([key, service]: any) => (
                    <Box key={key} mb={3} mr={3} border={'1px solid'} w={'150px'} p={3} borderRadius={'md'} borderColor={'gray.200'}>
                      <Text fontWeight="medium" color="blue.600">{key.toUpperCase()}</Text>
                      <Text fontSize="sm">Aktywny: {service.active === 1 ? "Tak" : "Nie"}</Text>
                    </Box>
                  ))}
                </Flex>
              </Box>
            ) : (
              <Text>Brak usług</Text>
            )}

            <Divider my={6} />

            <Heading fontSize="md" mb={2}>WiFi</Heading>
            {Array.isArray(wifi) && wifi.length > 0 ? (
              <Box pl={2}>
                {wifi.map((w: any, index: number) => {
                  const qrValue = `WIFI:T:${w.wifi_security || 'WPA'};S:${w.wifi_essid};P:${w.wifi_password};H:;;`;

                  return (
                    <Flex
                      key={index}
                      mb={4}
                      p={4}
                      borderWidth="1px"
                      borderRadius="md"
                      // justify="center"
                      align="flex-start"
                      flexWrap="wrap"
                    >

                      {w.wifi_essid && w.wifi_password && (
                        <Box textAlign="center" mr={[0, 4, 4]} mt={[0, 0, 0]} /* mt={3} display="flex" flexDirection="column" alignItems="center" */>
                          <QRCodeSVG
                            value={qrValue}
                            size={128}
                            level="H"
                          // includeMargin
                          />
                          <Text mt={1} fontSize={'sm'} ><strong>Zeskanuj aby połączyć</strong></Text>
                        </Box>
                      )}

                      <Box>
                        <Text><strong>SSID:</strong> {w.wifi_essid || "Brak"}</Text>
                        <Text><strong>Hasło:</strong> {w.wifi_password || "Brak"}</Text>
                        <Text><strong>Zabezpieczenia:</strong> {w.wifi_security || "Brak"}</Text>
                      </Box>


                    </Flex>
                  );
                })}
              </Box>
            ) : (
              <Text color="gray.500">Brak informacji o WiFi</Text>
            )}


            {/* {Array.isArray(wifi) && wifi.length > 0 ? (
              <Box pl={2}>
                {wifi.map((w: any, index: number) => {
                  const qrValue = `WIFI:T:${w.wifi_security || 'WPA'};S:${w.wifi_essid};P:${w.wifi_password};H:;;`;

                  return (
                    <Box key={index} mb={4} p={3} borderWidth="1px" borderRadius="md">
                      <Text><strong>SSID:</strong> {w.wifi_essid || "Brak"}</Text>
                      <Text><strong>Hasło:</strong> {w.wifi_password || "Brak"}</Text>
                      <Text><strong>Zabezpieczenia:</strong> {w.wifi_security || "Brak"}</Text>

                      {w.wifi_security && w.wifi_essid && w.wifi_password && (
                        <Box mt={3}>
                          <Text fontWeight="semibold" mb={1}>Kod QR do Wi-Fi</Text>
                          <QRCodeSVG
                            value={qrValue}
                            size={160}
                            level="H"
                            includeMargin
                          />
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <Text color="gray.500">Brak informacji o WiFi</Text>
            )} */}

            {/* {Array.isArray(wifi) && wifi.length > 0 ? (
              <Box pl={2}>
                {wifi.map((w: any, index: number) => (

                  
                  <Box key={index} mb={4} p={3} borderWidth="1px" borderRadius="md">
                    <Text><strong>SSID:</strong> {w.wifi_essid || "Brak"}</Text>
                    <Text><strong>Hasło:</strong> {w.wifi_password || "Brak"}</Text>
                    <Text><strong>Zabezpieczenia:</strong> {w.wifi_security || "Brak"}</Text>
                  </Box>
                ))}
              </Box>
            ) : (
              <Text color="gray.500">Brak informacji o WiFi</Text>
            )} */}

            <Divider my={6} />

            <Heading fontSize="md" mb={2}>Porty</Heading>
            {ports && Object.keys(ports).length ? (
              <Box pl={2}>
                <Flex wrap="wrap" gap={4}>

                  {Object.entries(ports).map(([port, details]: any) => (
                    <Box key={port} mb={3} mr={3} border={'1px solid'} minW={'160px'} p={3} borderRadius={'md'} borderColor={'gray.200'}>
                      <Text fontWeight="medium">Port {port}</Text>
                      <Text fontSize="sm">Usługa: {details.service}</Text>
                      {/* <Text fontSize="sm">VLAN: {details.vlan_active}</Text> */}
                      {/* <Text fontSize="sm">Opis: {details.vlan_description}</Text> */}
                    </Box>
                  ))}
                </Flex>
              </Box>
            ) : (
              <Text>Brak danych o portach</Text>
            )}
          </Box>
        </Container>
      </Fade>
    </>
  );
};
